import { useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

export default function Root() {
  const location = useLocation();

  if (location.pathname === '/') {
    window.location.href = '/user/profile';
  }

  return <Outlet />;
}
